import Vue from 'vue';
import _ from 'lodash';
import { Message, MessageBox } from 'element-ui';
import {
    // 提交数据
    POST_EDIT_COUPON_REQUEST,
    POST_EDIT_COUPONE_SUCCESS,
    POST_EDIT_COUPON_FAILURE,
    RESET_EDIT_COUPON_DATA,
    // 获取优惠券数据
    GET_BC_COUPON_REQUEST,
    GET_BC_COUPON_SUCCESS,
    GET_BC_COUPON_FAILURE,
    // 上架中的服务列表
    GET_PUT_SERVICE_LIST_REQUEST,
    GET_PUT_SERVICE_LIST_SUCCESS,
    GET_PUT_SERVICE_LIST_FAILURE,
    RESET_SELECT_PUT_SERVICE_LIST,
    HAS_PUT_SERVICE_MORE,
    REMOVE_SELECT_PUT_SERVICE_ITEM,
    // 上架中的爱车卡列表
    GET_STORE_CARD_LIST_REQUEST,
    GET_STORE_CARD_LIST_SUCCESS,
    GET_STORE_CARD_LIST_FAILURE,
    RESET_SELECT_STORE_CARD_LIST,
    REMOVE_SELECT_STORE_CARD_ITEM,
    HAS_CAR_CARD_MORE,
    // 上架中的营销活动
    GET_MARKETING_ACTIVITY_LIST_REQUEST,
    GET_MARKETING_ACTIVITY_LIST_SUCCESS,
    GET_MARKETING_ACTIVITY_FAILURE,
    RESET_SELECT_MARKETING_ACTIVITY_LIST,
    REMOVE_SELECT_MARKETING_ACTIVITY_ITEM,
    HAS_MARKETING_ACTIVITY_MORE,
} from '../mutationTypes';

const state = {
    loading: false,
    hasSelectActivitiyMore: false, // 选中营销活动是否还有更多
    hasActivitiyMore: false, // 上架中营销活动是否还有更多
    marketingActivitiyLoaing: false,
    hasSelectCardMore: false, // 选中爱车卡是否还有更多
    hasCardMore: false, // 上架中爱车卡是否还有更多
    storeCarLoaing: false,
    hasSelectServiceMore: false, // 选中服务是否还有更多
    hasServiceMore: false, // 上架中的服务是否还有更多
    serviceLoaing: false,
    marketingActivitiyList: [], // 营销活动列表
    selectmarketingActivitiyList: [], // 选中的营销活动列表
    storeCarList: [], // 爱车卡列表
    selectStoreCarList: [], // 选中的爱车卡列表
    serviceList: [], // 服务列表
    selectServiceList: [], // 选中的服务列表
    selectServiceListPage: [], // 选中的服务列表[页面]
    classificationList2: [], // 二级分类列表
    marketingActivityCount: 0, // 营销活动总条数
    storeCarCount: 0, // 爱车卡总条数
    serviceCount: 0, // 服务总条数
    marketingActivityPageCount: 0, // 营销活动总页数
    storeCarPageCount: 0, // 爱车卡总页数
    servicePageCount: 0, // 服务总页数
    couponData: {}, // 获取优惠券信息
    isSave: false, // 是否有投放or保存提交过数据
    postData: null, // post提交成功返回的数据
};

const mutations = {
    /**
     * 获取bc优惠券系列
     */
    [GET_BC_COUPON_REQUEST](state) {
        state.loading = true;
    },
    [GET_BC_COUPON_SUCCESS](state, res) {
        state.loading = false;
        state.couponData = res;
    },
    [GET_BC_COUPON_FAILURE](state, res) {
        state.loading = false;
        Message({
            message: res.errmsg,
            type: 'error'
        });
    },
    /**
     * 营销活动系列
     */
    [REMOVE_SELECT_MARKETING_ACTIVITY_ITEM](state, val) {
        state.selectmarketingActivitiyList.splice(val.index, 1);
    },
    [RESET_SELECT_MARKETING_ACTIVITY_LIST](state) {
        state.selectmarketingActivitiyList = [];
    },
    [HAS_MARKETING_ACTIVITY_MORE](state, query) {
        if (state.selectmarketingActivitiyList.length < query.marketingActivitiyIds.length) {
            state.hasSelectActivitiyMore = true;
        } else {
            state.hasSelectActivitiyMore = false;
        }
    },
    [GET_MARKETING_ACTIVITY_LIST_REQUEST](state) {
        state.marketingActivitiyLoaing = true;
    },
    [GET_MARKETING_ACTIVITY_LIST_SUCCESS](state, res) {
        state.marketingActivitiyLoaing = false;
        if (res.type) {
            // get 选择的营销活动列表
            state.selectmarketingActivitiyList = state.selectmarketingActivitiyList.concat(res.marketing_activitiy_list);
        } else {
            state.marketingActivityPageCount = res.page_count || 0;
            state.marketingActivityCount = res.count || 0;
            if (res.page === 1) {
                state.marketingActivitiyList = res.marketing_activitiy_list;
            } else {
                state.marketingActivitiyList = state.marketingActivitiyList.concat(res.marketing_activitiy_list);
            }
            // 是否加载更多
            if (res.page < res.page_count) {
                state.hasActivitiyMore = true;
            } else {
                state.hasActivitiyMore = false;
            }
        }
    },
    [GET_MARKETING_ACTIVITY_FAILURE](state, res) {
        state.marketingActivitiyLoaing = false;
        Message({
            message: res.errmsg,
            type: 'error'
        });
    },
    /**
     * 爱车卡系列
     */
    [REMOVE_SELECT_STORE_CARD_ITEM](state, val) {
        state.selectStoreCarList.splice(val.index, 1);
    },
    [RESET_SELECT_STORE_CARD_LIST](state) {
        state.selectStoreCarList = [];
    },
    [HAS_CAR_CARD_MORE](state, query) {
        if (state.selectStoreCarList.length < query.storeCarIds.length) {
            state.hasSelectCardMore = true;
        } else {
            state.hasSelectCardMore = false;
        }
    },
    [GET_STORE_CARD_LIST_REQUEST](state) {
        state.storeCarLoaing = true;
    },
    [GET_STORE_CARD_LIST_SUCCESS](state, res) {
        state.storeCarLoaing = false;
        if (res.type) {
            // get 选择的爱车卡列表
            state.selectStoreCarList = state.selectStoreCarList.concat(res.cardData);
        } else {
            state.storeCarPageCount = res.page_count || 0;
            state.storeCarCount = res.count || 0;
            if (res.page === 1) {
                state.storeCarList = res.cardData;
            } else {
                state.storeCarList = state.storeCarList.concat(res.cardData);
            }
            // 是否加载更多
            if (res.page < res.page_count) {
                state.hasCardMore = true;
            } else {
                state.hasCardMore = false;
            }
        }
    },
    [GET_STORE_CARD_LIST_FAILURE](state, res) {
        state.storeCarLoaing = false;
        Message({
            message: res.errmsg,
            type: 'error'
        });
    },
    /**
     * 服务系列
     */
    [GET_PUT_SERVICE_LIST_REQUEST](state) {
        state.serviceLoaing = true;
    },
    [GET_PUT_SERVICE_LIST_SUCCESS](state, res) {
        state.serviceLoaing = false;
        // get 选择的服务列表
        if (res.type) {
            state.selectServiceList = state.selectServiceList.concat(res.dataList);
        } else {
            state.servicePageCount = res.pageCount || 0;
            state.serviceCount = res.count || 0;
            if (res.page === 1) {
                state.serviceList = res.dataList;
            } else {
                state.serviceList = state.serviceList.concat(res.dataList);
            }
            if (res.page < res.pageCount) {
                state.hasServiceMore = true;
            } else {
                state.hasServiceMore = false;
            }
        }
    },
    [GET_PUT_SERVICE_LIST_FAILURE](state, res) {
        state.serviceLoaing = false;
        Message({
            message: res.errmsg,
            type: 'error'
        });
    },
    [RESET_SELECT_PUT_SERVICE_LIST](state) {
        _.extend(state, _.cloneDeep({
            selectServiceList: [],
        }));
    },
    [HAS_PUT_SERVICE_MORE](state, query) {
        if (state.selectServiceList.length < query.serviceIds.length) {
            state.hasSelectServiceMore = true;
        } else {
            state.hasSelectServiceMore = false;
        }
    },
    [REMOVE_SELECT_PUT_SERVICE_ITEM](state, val) {
        state.selectServiceList.splice(val.index, 1);
    },
    /**
     * 提交数据系列
     */
    // post提交数据
    [POST_EDIT_COUPON_REQUEST](state) {
        state.loading = true;
    },
    [POST_EDIT_COUPONE_SUCCESS](state, res) {
        state.loading = false;
        state.postData = res;
        state.isSave = true;
    },
    [POST_EDIT_COUPON_FAILURE](state, res) {
        state.loading = false;
        state.isSave = false;

        MessageBox.alert(res.errmsg || '未知错误', '操作失败！', {
            confirmButtonText: '知道了'
        });
    },
    [RESET_EDIT_COUPON_DATA](state) {
        state.couponData = {};
        state.isSave = false;
        state.postData = null;
    },
};

export const actions = {
    /**
     * 获取bc优惠券系列
     */
    async getBcCouponData({ commit }, query) {
        commit(GET_BC_COUPON_REQUEST);
        const res = await Vue.$ajax.get('getBcCoupon', query);
        if (!res.errorType) {
            commit(GET_BC_COUPON_SUCCESS, res);
        } else {
            commit(GET_BC_COUPON_FAILURE, res);
        }
    },
    /**
     * 营销活动系列
     */
    // 移除已选marketingActivitiyList
    removeActivitiyItem({ commit }, query) {
        commit(REMOVE_SELECT_MARKETING_ACTIVITY_ITEM, query);
    },
    // 重置marketingActivitiyList
    resetActivitiyList({ commit }) {
        commit(RESET_SELECT_MARKETING_ACTIVITY_LIST);
    },
    // 是否还有选中的营销活动
    hasActivitiyMoreFn({ commit }, query) {
        commit(HAS_MARKETING_ACTIVITY_MORE, query);
    },
    // 获取上架的营销活动列表
    async getActivitiyList({ commit }, query) {
        commit(GET_MARKETING_ACTIVITY_LIST_REQUEST);
        const res = await Vue.$ajax.get('getServicePackage', query);
        const re = _.extend({}, res, _.pick(query, ['type']));
        if (!res.errorType) {
            commit(GET_MARKETING_ACTIVITY_LIST_SUCCESS, re);
        } else {
            commit(GET_MARKETING_ACTIVITY_FAILURE, re);
        }
    },
    /**
     *爱车卡系列
     */
    // 移除已选storeCarList
    removeCarItem({ commit }, query) {
        commit(REMOVE_SELECT_STORE_CARD_ITEM, query);
    },
    // 重置storeCarList
    resetStoreCarList({ commit }) {
        commit(RESET_SELECT_STORE_CARD_LIST);
    },
    // 是否还有选中的爱车卡
    hasCarCardMore({ commit }, query) {
        commit(HAS_CAR_CARD_MORE, query);
    },
    // 获取上架的爱车卡列表
    async getStoreCardList({ commit }, query) {
        commit(GET_STORE_CARD_LIST_REQUEST);
        const res = await Vue.$ajax.get('storeCardList', query);
        const re = _.extend({}, res, _.pick(query, ['type']));
        if (!res.errorType) {
            commit(GET_STORE_CARD_LIST_SUCCESS, re);
        } else {
            commit(GET_STORE_CARD_LIST_FAILURE, re);
        }
    },
    /**
     * 服务系列
     */
    // 获取上架服务列表
    async getPutServiceList({commit}, query) {
        commit(GET_PUT_SERVICE_LIST_REQUEST);
        const res = await Vue.$ajax.get('getSelectService', query);
        const re = _.extend({}, res, _.pick(query, ['type']));

        if (!res.errorType) {
            commit(GET_PUT_SERVICE_LIST_SUCCESS, re);
        } else {
            commit(GET_PUT_SERVICE_LIST_FAILURE, re);
        }
    },

    // 重置已选的selesctPutServiceList
    resetSelectPutServiceList({ commit }) {
        commit(RESET_SELECT_PUT_SERVICE_LIST);
    },
    // 是否还有选中的服务
    hasServiceMoreFn({ commit }, query) {
        commit(HAS_PUT_SERVICE_MORE, query);
    },
    // 移除已选selesctPutServiceList
    removeServiceItem({ commit }, query) {
        commit(REMOVE_SELECT_PUT_SERVICE_ITEM, query);
    },
    /**
     * 提交数据系列
     */
    async postEditCoupon({commit}, query) {
        commit(POST_EDIT_COUPON_REQUEST);
        const res = await Vue.$ajax.post('postEditCoupon', query);
        if (!res.errcode) {
            commit(POST_EDIT_COUPONE_SUCCESS, res);
        } else {
            commit(POST_EDIT_COUPON_FAILURE, res);
        }
    },
    // reset 提交数据
    resetEditCoupon({commit}) {
        commit(RESET_EDIT_COUPON_DATA);
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/editCoupon.js